import { render, staticRenderFns } from "./pointschangedlog-add-or-update.vue?vue&type=template&id=633dc431&"
import script from "./pointschangedlog-add-or-update.vue?vue&type=script&lang=js&"
export * from "./pointschangedlog-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports